import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

import { SERVER_URL } from "@/config/config";
import {
  LeaderboardEntry,
  LeaderboardPagination,
  RefereeData,
} from "@/types/ReferralInfo";

export interface ReferralState {
  referralCode: string;
  isLoadingReferralCode: boolean;
  refereeList: RefereeData[];
  isLoadingRefereeList: boolean;
  leaderboard: LeaderboardEntry[];
  leaderboardPagination: LeaderboardPagination | null;
  isLoadingLeaderboard: boolean;
}

const initialState: ReferralState = {
  referralCode: "",
  isLoadingReferralCode: false,
  refereeList: [],
  isLoadingRefereeList: false,
  leaderboard: [],
  leaderboardPagination: null,
  isLoadingLeaderboard: false,
};

export const getRefereeListAction = createAsyncThunk(
  "referral/getRefereeListAction",
  async (account: string) => {
    const response = await axios.get(
      SERVER_URL + "/referral/referees/" + account
    );
    return response.data;
  }
);

export const getLeaderboardAction = createAsyncThunk(
  "referral/getLeaderboardAction",
  async ({ limit = 50, offset = 0 }: { limit?: number; offset?: number }) => {
    const response = await axios.get(
      SERVER_URL + "/referral/leaderboard?limit=" + limit + "&offset=" + offset
    );
    return response.data;
  }
);

export const getReferralCodeAction = createAsyncThunk(
  "referral/getReferralCodeAction",
  async (account: string) => {
    const response = await axios.get(SERVER_URL + "/referral/code/" + account);
    return response.data;
  }
);

const referralSlice = createSlice({
  name: "referral",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getReferralCodeAction.pending, (state) => {
        state.isLoadingReferralCode = true;
      })
      .addCase(getReferralCodeAction.fulfilled, (state, { payload }) => {
        state.referralCode = payload.data.referralCode;
        state.isLoadingReferralCode = false;
      })
      .addCase(getReferralCodeAction.rejected, (state, { error }) => {
        state.isLoadingReferralCode = false;
        console.error(error);
      })
      .addCase(getRefereeListAction.pending, (state) => {
        state.isLoadingRefereeList = true;
      })
      .addCase(getRefereeListAction.fulfilled, (state, { payload }) => {
        state.refereeList = payload.success && payload.data ? payload.data : [];
        state.isLoadingRefereeList = false;
      })
      .addCase(getRefereeListAction.rejected, (state, { error }) => {
        state.isLoadingRefereeList = false;
        console.error(error);
      })
      .addCase(getLeaderboardAction.pending, (state) => {
        state.isLoadingLeaderboard = true;
      })
      .addCase(getLeaderboardAction.fulfilled, (state, { payload }) => {
        if (payload.success && payload.data) {
          state.leaderboard = payload.data;
          state.leaderboardPagination = payload.pagination;
        } else {
          state.leaderboard = [];
          state.leaderboardPagination = null;
        }
        state.isLoadingLeaderboard = false;
      })
      .addCase(getLeaderboardAction.rejected, (state, { error }) => {
        state.isLoadingLeaderboard = false;
        console.error(error);
      });
  },
});

export default referralSlice.reducer;